module.exports = __webpack_public_path__ + "img/floating-image-1@3x.33d13824.png";